import React, { useRef } from 'react';
import useResizedPostImage from '../../../../../../hooks/useResizedPostImage';
import urlApi from '../../../../../../actions/urlApi';
import { PageImageWrapper, ImageDescription, ImageContent } from '../styles';
import AspectRatio from '../../../../../AspectRatio';
var MagazineImage = function (_a) {
    var _b, _c;
    var post = _a.post;
    var container = useRef();
    var _d = useResizedPostImage(post, container), originalImage = _d[0], resize = _d[1];
    var _e = ((_c = (_b = post.attachments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.originalImageInfo) || {}, width = _e.width, height = _e.height;
    var _f = resize || {}, resizedImage = _f.url, ratio = _f.ratio;
    var finalRatio = ratio || width / height;
    var isVertical = finalRatio < 1;
    var Wrapper = isVertical ? ImageContent : AspectRatio;
    return (React.createElement(PageImageWrapper, { ref: container, vertical: isVertical },
        React.createElement(Wrapper, { ratio: finalRatio },
            React.createElement("img", { src: "".concat(urlApi().getImageQueryLink()).concat(resizedImage) })),
        React.createElement(ImageDescription, null, post.caption)));
};
export default MagazineImage;
//# sourceMappingURL=MagazineImage.js.mapimport React, { useRef } from 'react';
import useResizedPostImage from '../../../../../../hooks/useResizedPostImage';
import urlApi from '../../../../../../actions/urlApi';
import { PageImageWrapper, ImageDescription, ImageContent } from '../styles';
import AspectRatio from '../../../../../AspectRatio';
var MagazineImage = function (_a) {
    var _b, _c;
    var post = _a.post;
    var container = useRef();
    var _d = useResizedPostImage(post, container), originalImage = _d[0], resize = _d[1];
    var _e = ((_c = (_b = post.attachments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.originalImageInfo) || {}, width = _e.width, height = _e.height;
    var _f = resize || {}, resizedImage = _f.url, ratio = _f.ratio;
    var finalRatio = ratio || width / height;
    var isVertical = finalRatio < 1;
    var Wrapper = isVertical ? ImageContent : AspectRatio;
    return (React.createElement(PageImageWrapper, { ref: container, vertical: isVertical },
        React.createElement(Wrapper, { ratio: finalRatio },
            React.createElement("img", { src: "".concat(urlApi().getImageQueryLink()).concat(resizedImage) })),
        React.createElement(ImageDescription, null, post.caption)));
};
export default MagazineImage;
//# sourceMappingURL=MagazineImage.js.map